import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import dataFlags from "../../data/bait-to-plate/data-flags-combined.json";

const FlagLegendItem = ({ flagSlug, as = "span", linked = false }) => {
  const flag = dataFlags.find(flag => flag.slug === flagSlug);
  let className = "";
  let flagName = flagSlug ;
  if ( ! flag ) {
    if ( flagSlug === "human-rights" ) {
      className = "is-human-rights";
      flagName = "Human Rights & Labor";
    }
    else if ( flagSlug === "environmental" ) {
      className = "is-environmental";
      flagName = "Fishing & Environmental";
    }
  }
  else if ( flag.slug === "uyghur-labor" || flag.slug === "north-korean-labor" ) {
    className = ` is-${flag.slug}`;
  }
  else {
    className = flag.is_human_rights_concern ? "is-human-rights" : flag.is_environmental_concern ? "is-environmental" : undefined;
  }
  return (
    <StyledFlagLegendItem as={as} className={className}>
      <span>{linked && "* "}{flag ?  flag.name : flagName}</span>
    </StyledFlagLegendItem>
  );
};

export default FlagLegendItem;

const StyledFlagLegendItem = styled.span`
  position: relative;
  display: inline-block;
  line-height: 1.3;
  z-index: 0;
  font-weight: 700;
  font-size: 0.75em;
  padding: 0.125em 0.3em 0.1875em 1em;
  padding: 0.125em 0.5em;
  //border: 1px solid rgba(0,0,0,0.12);
  border-radius: 0.25em;
  color: var(--color-black);
  &::before {
    content: "";
    display: block;
    position: absolute;
    z-index: -1;
    border-radius: 0.25em;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-radius: inherit;
    background-color: currentColor;
  }
  /*&::after {
    content: "";
    display: block;
    position: absolute;
    z-index: -1;
    border-radius: 0.25em;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    border-radius: 0.25em;
    border: 1.5px solid currentColor;
  }*/
  &.is-human-rights::before,
  &.is-human-rights::after {
    color: var(--color-hr);
  }
  &.is-environmental::before,
  &.is-environmental::after {
    color: var(--color-env);
  }
  &.is-uyghur-labor::before,
  &.is-uyghur-labor::after {
    color: var(--color-uyg);
  }
  &.is-north-korean-labor::before,
  &.is-north-korean-labor::after {
    color: var(--color-nk);
  }
`;

export { StyledFlagLegendItem };